import { CheckCircle2 } from 'lucide-react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { GuideMascotCallout } from '../components/GuideMascotCallout'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../../theme/onboardingTheme'

const miscRhodeIslandUsername = 'MISC_RI'

export function StepRhodeIslandTaxPortalAccess() {
  const { dispatch, advance } = useOnboarding()

  const acknowledgeAndContinue = () => {
    dispatch({ type: 'ACK_RHODE_ISLAND_TAX_PORTAL_ACCESS' })
    advance()
  }

  return (
    <Stack spacing={2.5} sx={{ mx: 'auto', maxWidth: '56rem' }}>
      <Box>
        <Typography
          component="h2"
          sx={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.025em', color: '#0f172a' }}
        >
          Rhode Island Tax Portal Third-Party Access
        </Typography>
        <Typography component="p" sx={{ mt: 1, fontSize: 14, lineHeight: 1.625, color: '#475569' }}>
          Rhode Island requires one more portal access step before MISC can file on your behalf.
        </Typography>
      </Box>

      <GuideMascotCallout centered>
        Please login to the Rhode Island Tax Portal account of the licensed{' '}
        <Box component="strong" sx={{ fontWeight: 700, color: MISC_PRIMARY }}>
          ENTITY
        </Box>{' '}
        (preferred, or individual
        if no entity account exists) and share 3rd party access with our MISC username:{' '}
        <Box
          component="code"
          sx={{
            borderRadius: '6px',
            backgroundColor: '#f1f5f9',
            px: 1,
            py: 0.5,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#0f172a',
          }}
        >
          {miscRhodeIslandUsername}
        </Box>
      </GuideMascotCallout>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          borderRadius: '12px',
          border: '1px solid #bfdbfe',
          backgroundColor: '#eff6ff',
          px: 2,
          py: 2,
          textAlign: 'center',
        }}
      >
        <Button
          type="button"
          onClick={acknowledgeAndContinue}
          startIcon={<CheckCircle2 size={16} />}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            borderRadius: '8px',
            backgroundColor: MISC_PRIMARY,
            px: 2.5,
            py: 1.25,
            fontSize: 14,
            fontWeight: 600,
            color: '#ffffff',
            boxShadow: 1,
            textTransform: 'none',
            '&:hover': { backgroundColor: MISC_PRIMARY_HOVER },
          }}
        >
          I shared Rhode Island Tax Portal third-party access
        </Button>
      </Box>
    </Stack>
  )
}
